<template>
  <div class="PublicityDetail6">
    <h3>3·15金融消费者权益保护教育宣传活动丨保障金融权益 助力美好生活</h3>
    <img :src="require('../images/ic_publicity_detail6_1.jpg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail6_2.jpg')"/>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail6'
};
</script>

<style scoped lang="less">
.PublicityDetail6 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  div {
    text-align: left;
  }

  img {
    width: 100%;
    margin-top: 30px;
    align-self: center;
  }
}
</style>
